module.exports = __webpack_public_path__ + "static/img/character-taurus.90798f83.png";